import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import Menu from 'ui-library/menus/Menu';
import {MenuWidth} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';

export interface VersionHistoryItemOption {
  text: string;
  icon: BenchlingIconName;
  onClick?: () => void;
}

export interface VersionHistoryItemActionMenuProps {
  firstOption: VersionHistoryItemOption;
  secondOption: VersionHistoryItemOption;
}

export default function VersionHistoryItemActionMenu({
  firstOption,
  secondOption,
}: VersionHistoryItemActionMenuProps): JSX.Element {
  return (
    <Menu width={MenuWidth.FIT_CONTENT} dropLeft={true}>
      {firstOption.onClick && (
        <Option
          key="version-history-item-option-first-key"
          onSelect={firstOption.onClick}
          dataTestAttrs={{component: 'VersionHistoryItemActionMenu', element: 'firstOption'}}
        >
          <div className={css(styles.dropdownOption)}>
            <span>
              <BenchlingIcon icon={firstOption.icon} />
            </span>
            <span>{firstOption.text}</span>
          </div>
        </Option>
      )}
      {secondOption.onClick && (
        <Option
          key="version-history-item-option-second-key"
          onSelect={secondOption.onClick}
          dataTestAttrs={{component: 'VersionHistoryItemActionMenu', element: 'secondOption'}}
        >
          <div className={css(styles.dropdownOption)}>
            <span className={css(styles.icon)}>
              <BenchlingIcon icon={secondOption.icon} />
            </span>
            <span>{secondOption.text}</span>
          </div>
        </Option>
      )}
    </Menu>
  );
}

const styles = StyleSheet.create({
  dropdownOption: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.6em',
    color: Color.GRAY_900,
  },
  icon: {
    color: Color.GRAY_600,
  },
});
